import React, {useState, useContext} from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Hidden from '@material-ui/core/Hidden'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

import PersonIcon from '@material-ui/icons/Person'
import PhoneIcon from '@material-ui/icons/Phone'
import MailIcon from '@material-ui/icons/Mail'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import {CircularProgress} from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';

import validate from 'validate.js'

import constraints from '../../../utils/constraints.js'
import styles from './UserSettingsDialog.module.css'
import ReceiptsDialog from '../../ReceiptsDialog'

import _appContext from '../../../contexts/appContext'
import _firebaseContext from '../../../contexts/firebaseContext'

export default function UserSetingsDialog({ open, handleClose, user }) {
    const [performingAction, setPerformingAction] = useState(true)
    const [name, setName] = useState(user.data.name || '')
    const [surname, setSurname] = useState(user.data.surname || '')
    const [email, setEmail] = useState(user.data.email || '')
    const [phone, setPhone] = useState(user.data.phone || '')
    const [role, setRole] = useState(user.data.role || 'user')
    const [isLoading, setIsLoading] = useState(false);
    const [unlimMessagesAllow, setUnlimMessagesAllow] = useState(user.data.unlimMessagesAllow || false)

    const [receiptsDialog, setReceiptsDialog] = useState(false)

    const openReceiptsDialog = () => {
        setReceiptsDialog(true)
    }
    const handleReceiptsDialog = () => {
        setReceiptsDialog(false)
    }

    const [errors, setErrors] = useState({
        email: false,
    })

    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)

    const handleNameChange = (event) => {
        setName(event.target.value)
    }
    const handleSurnameChange = (event) => {
        setSurname(event.target.value)
    }
    const handleRoleChange = (event) => {
        setRole(event.target.value)
    }
    const handleMailChange = (event) => {
        setEmail(event.target.value)
    }
    const handlePhoneChange = (event) => {
        setPhone(event.target.value)
    }
    const handleChangeUnlimMessagesAllow = (event) => {
        setUnlimMessagesAllow(event.target.checked)
    }

    const handlePasswordReset = async (event) => {
        setIsLoading(true);
        const result = await firebaseContext.resetPassword(user.data.email)
        setIsLoading(false);
        appContext.snackbar.showSnackbarMsg(result.message)
    }

    const handleShowSubscriptions = async (event) => {
        openReceiptsDialog()
    }

    const handleSave = async (event) => {
        setIsLoading(true);
        const errors = validate(
            {
                // email,
                // password,
            },
            {
                // email: constraints.email,
                // password: constraints.password
            }
        )

        if (errors) {
            setIsLoading(false);
            setErrors(errors)
        } else {
            const updatedUser = {
                name: name.trim(),
                represent: name.trim().toLowerCase(),
                surname: surname.trim(),
                email: email.trim(),
                role: role.trim(),
                phone: phone.trim(),
                unlimMessagesAllow: unlimMessagesAllow,
            }
            let result = await firebaseContext.updateUser(user.id, updatedUser)

            if (result.error) {
                if (result.firebaseError !== undefined) {
                    const code = result.firebaseError.errorInfo.code
                    let reason = code

                    switch (code) {
                        case 'auth/too-many-requests':
                            reason = 'Слишком много запросов'
                            break
                        case 'auth/user-not-found':
                            reason = 'Пользователь не найден'
                            break
                        case 'auth/invalid-email':
                            reason = 'Недопустимый адрес электронной почты'
                            setErrors({
                                email: ['Недопустимый адрес электронной почты'],
                            })
                            break
                        case 'auth/invalid-password':
                            reason = 'Недопустимый пароль'
                            setErrors({
                                password: ['Недопустимый пароль'],
                            })
                            break
                        case 'auth/email-already-exists':
                            reason = 'Указаная почта уже используется'
                            setErrors({
                                email: ['Указаная почта уже используется'],
                            })
                            break
                        case 'auth/insufficient-permission':
                            reason = 'Нет доступа'
                            break
                        case 'auth/internal-error':
                            reason = 'Проблемы с сервером авторизации'
                            break
                        case 'auth/invalid-argument':
                            reason = 'Некорректные данные'
                            break
                        case 'auth/invalid-password':
                            reason = 'Недопустимый пароль'
                            setErrors({
                                password: ['Недопустимый пароль'],
                            })
                            break
                        case 'auth/invalid-phone-number':
                            reason = 'Недопустимый номер телефона'
                            setErrors({
                                phone: ['Недопустимый номер телефона'],
                            })
                            break
                        case 'auth/phone-number-already-exists':
                            reason =
                                'Пользователь с указанным номером уже существует'
                            setErrors({
                                phone: [
                                    'Пользователь с указанным номером уже существует',
                                ],
                            })
                            break
                    }
                    result.message = reason
                }
            } else {
                setIsLoading(false);
                handleClose()
            }
            setIsLoading(false);
            appContext.snackbar.showSnackbarMsg(result.message)
        }
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            maxWidth="sm"
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">
                Настройки пользователя
            </DialogTitle>
            <DialogContent>
                {
                    isLoading &&
                    <Backdrop style={{zIndex: 10000}} open={true}>
                        <CircularProgress style={{color: '#FFF'}}/>
                    </Backdrop>
                }
                <List>
                    <ListItem>
                        <Hidden xsDown>
                            <ListItemIcon>
                                <PersonIcon />
                            </ListItemIcon>
                        </Hidden>
                        <TextField
                            autoFocus
                            disabled={!performingAction}
                            // error={!!(errors && errors.firstName)}
                            fullWidth
                            label="Имя пользователя"
                            required
                            type="text"
                            value={name}
                            className={styles.textfield}
                            onChange={handleNameChange}
                        />
                    </ListItem>
                    <ListItem>
                        <Hidden xsDown>
                            <ListItemIcon>
                                <PersonIcon />
                            </ListItemIcon>
                        </Hidden>

                        <TextField
                            autoFocus
                            disabled={!performingAction}
                            // error={!!(errors && errors.firstName)}
                            fullWidth
                            label="Фамилия пользователя"
                            required
                            type="text"
                            value={surname}
                            className={styles.textfield}
                            onChange={handleSurnameChange}
                        />
                    </ListItem>
                    <ListItem>
                        <Hidden xsDown>
                            <ListItemIcon>
                                <AssignmentIndIcon />
                            </ListItemIcon>
                        </Hidden>

                        <FormControl fullWidth className={styles.textfield}>
                            <InputLabel id="user-role-select-label">
                                Роль
                            </InputLabel>
                            <Select
                                labelId="user-role-select-label"
                                id="user-role-select"
                                value={role}
                                onChange={handleRoleChange}
                            >
                                <MenuItem value={'user'}>user</MenuItem>
                                <MenuItem value={'admin'}>admin</MenuItem>
                                <MenuItem value={'streamer'}>streamer</MenuItem>
                            </Select>
                        </FormControl>
                    </ListItem>
                    <ListItem>
                        <Hidden xsDown>
                            <ListItemIcon>
                                <MailIcon />
                            </ListItemIcon>
                        </Hidden>

                        <TextField
                            autoFocus
                            disabled={!performingAction}
                            error={!!(errors && errors.email)}
                            helperText={
                                errors && errors.email ? errors.email[0] : ''
                            }
                            fullWidth
                            label="Почта пользователя"
                            required
                            type="email"
                            value={email}
                            className={styles.textfield}
                            onChange={handleMailChange}
                        />
                    </ListItem>
                    <ListItem>
                        <Hidden xsDown>
                            <ListItemIcon>
                                <PhoneIcon />
                            </ListItemIcon>
                        </Hidden>

                        <TextField
                            autoFocus
                            disabled={!performingAction}
                            error={!!(errors && errors.phone)}
                            helperText={
                                errors && errors.phone ? errors.phone[0] : ''
                            }
                            fullWidth
                            label="Номер пользователя"
                            placeholder="+11234567890"
                            required
                            type="phone"
                            value={phone}
                            className={styles.textfield}
                            onChange={handlePhoneChange}
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={unlimMessagesAllow}
                                    onChange={handleChangeUnlimMessagesAllow}
                                    value="onlyActive"
                                />
                            }
                            label="Разрешить безлимитные сообщения"
                        />
                    </ListItem>
                    <ListItem>
                        <Button
                            color="primary"
                            // disabled={!emailAddress || performingAction}
                            variant="contained"
                            onClick={handlePasswordReset}
                        >
                            Сбросить пароль
                        </Button>
                    </ListItem>
                    <ListItem>
                        <Button
                            color="primary"
                            // disabled={!emailAddress || performingAction}
                            variant="contained"
                            onClick={handleShowSubscriptions}
                        >
                            Детализация подписки
                        </Button>
                    </ListItem>
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Отмена
                </Button>
                <Button onClick={handleSave} color="primary">
                    Сохранить
                </Button>
            </DialogActions>
            {receiptsDialog && (
                <ReceiptsDialog
                    open={receiptsDialog}
                    onClose={handleReceiptsDialog}
                    user={user}
                />
            )}
        </Dialog>
    )
}
